import { createSlice } from "@reduxjs/toolkit";
import * as Actions from "../actions";
import { dataOcorrensReducer } from "../reducers";
import { InitialState } from "./models";

const initialState: InitialState = {
  items: [],
  itemsVariaveis: [],
  dialogForm: {
    open: false,
    content: {
      mode: "",
      values: null,
    },
  },
  requestGetParams: {},
  pagination: {
    page: 0,
    rowsPerPage: 15,
    totalPages: 0,
    totalItems: 0,
  },
  configTabs: {
    tabInView: 0,
    tabs: [
      {
        title: "Ocorrências",
        index: 0,
        active: true,
        name: "ocorrencias",
      },
    ],
  },
};

const ocorrenciasSlice = createSlice({
  name: "ocorrenciasApp/ocorrencias",
  initialState,
  reducers: {
    changeTab: (state, action) => {
      state.configTabs.tabInView = action.payload;
    },
    openDialogForm: (state, action) => {
      state.dialogForm = {
        open: true,
        content: action.payload,
      };
    },
    closeDialogForm: (state) => {
      state.dialogForm = {
        open: false,
        content: {
          mode: "",
          values: null,
        },
      };
    },
  },
  extraReducers: (builder) => {
    builder.addCase(Actions.getOcorrens.fulfilled, dataOcorrensReducer);
  },
});

export const { changeTab, openDialogForm, closeDialogForm } =
  ocorrenciasSlice.actions;

export default ocorrenciasSlice.reducer;
